import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    padding: 12,
    marginTop: 12,
    alignSelf: "center",
    alignItems: "center",
    marginHorizontal: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  contentBtn: {
    marginTop: 16,
    padding: 10,
    width: 300,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  btn: {
    padding: 10,
    borderRadius: 20,
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
  contentBtnDelete: {
    marginBottom: 20,
    marginTop: 20,
  },
  textBtnDelete: {
    color: "#BC1010",
    textAlign: "center",
    textDecorationLine: "underline",
    fontWeight: "normal",
  },
});

export default styles;
